// Small music helpers shared by the Music page and the voice assistant (kept
// out of the Music page so the assistant doesn't pull that page in).

// The room is remembered by its lead speaker: Sonos group ids change whenever speakers are regrouped.
const ROOM_KEY = 'arlo:sonos-room';

export function savedRoom(): string | undefined {
  try {
    return localStorage.getItem(ROOM_KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

export function saveRoom(id: string): void {
  try {
    localStorage.setItem(ROOM_KEY, id);
  } catch {
    /* storage unavailable */
  }
}

const PLAY = /^\s*(?:(?:please|can you|could you|hey|ok)\s*,?\s+)*(?:play|put on|stick on|pop on)\s+(.+)/i;
// "Play with his ball for ten minutes", "put on his harness": that's Arlo, not music.
const NOT_MUSIC = /\b(with|ball|toys?|tug|fetch|chase|minutes?|mins?|garden|session|bit(e|ing)|harness|collar|lead|coat|jumper|jacket|nappy|cream|drops)\b/i;

/** "Play Wonderwall", "put on something calm" — a request for music, not a log entry. */
export function looksLikeMusic(text: string): boolean {
  const m = PLAY.exec(text);
  return !!m && !NOT_MUSIC.test(m[1]);
}
